<template>
  <a-config-provider :theme="{
    token: {
      colorPrimary: '#0a543f',
    },
  }">
    <router-view></router-view>

  </a-config-provider>
</template>

<script>
import useAuth from './composables/useAuth'
import AuthApi from './api/auth'
import TranslationApi from './api/translation'

export default {
    name: 'App',
    methods: {
        async getProfile() {
            const authApi = new AuthApi()

            if (!useAuth().get().authenticated) {
                return;
            }

            try {
                let r;

                if (useAuth().get().isMentor === 'true') {
                    r = await authApi.getMentorProfile()
                } else {
                    r = await authApi.getProfile()
                }

                if (!r.data) {
                    return;
                }

                useAuth().set(JSON.stringify(r.data), useAuth().get().token, useAuth()?.get()?.authenticated, useAuth().get().isMentor === 'true')
            } catch (error) {
            }
        },

        async getTranslations() {
            const translationApi = new TranslationApi()
            try {
                const r = await translationApi.getTranslations('id')
                if (r.data) {
                    localStorage.setItem('translations', JSON.stringify(r.data))
                }
            } catch (error) {
                console.error('Failed to fetch translations:', error)
            }
        }
    },

    mounted() {
        this.getProfile();
        this.getTranslations();
        if (window.__SEO__) {
            delete window.__SEO__
        }
    }
    // Tes
}
</script>